import { css, cx } from '@emotion/css';
import { Spin } from 'antd';
import { FC, ReactNode } from 'react';
import { antdPrefixCls } from 'styles';

const FillSpin: FC<{
  className?: string;
  spinning?: boolean;
  wrapperClassName?: string;
  isOverflowAuto?: boolean;
  tip?: ReactNode;
  children?: ReactNode;
}> = ({ className, spinning, children, wrapperClassName, isOverflowAuto, tip }) => {
  return (
    <Spin
      size="large"
      wrapperClassName={cx(styleSpin(isOverflowAuto), wrapperClassName)}
      spinning={spinning}
      className={className}
      tip={tip}
    >
      {children}
    </Spin>
  );
};

export const CenteredSpin: FC<{
  className?: string;
  spinning?: boolean;
  children?: ReactNode;
}> = ({ className, spinning, children }) => {
  return (
    <div className={cssCenteredSpin}>
      <Spin size="large" spinning={spinning} className={className}>
        {children}
      </Spin>
    </div>
  );
};

const styleSpin = (isOverflowAuto?: boolean) => css`
  height: 100%;
  width: 100%;
  overflow: hidden;
  min-width: 1100px;

  > div {
    > .${antdPrefixCls}-spin-lg {
      max-height: none !important;
      height: 100%;

      > .anticon {
        font-size: 30px !important;
        margin: -12px !important;
      }
    }
  }
  .${antdPrefixCls}-spin-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: ${isOverflowAuto ? 'auto' : ''};
  }
  .${antdPrefixCls}-spin-text {
    padding-top: 30px !important;
  }
`;

const cssCenteredSpin = css`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
`;

export default FillSpin;
